import { Images } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { PageView } from "../../../shared/components/PageView.tsx";

import { GenerationList } from "./GenerationList.tsx";

export const GenerationsView: FC = () => (
  <PageView
    icon={<Images />}
    subtitle="The images your agents generate, newest first."
    title="Generations"
  >
    <GenerationList />
  </PageView>
);
